import React from 'react';
import PropTypes from 'prop-types';
import InfoCard from './InfoCard/InfoCard.component';

const Part2Checker = ({ course }) => {
  return (
    <div>
      {course?.partTwo && (
        <InfoCard
          paragraph="
          Part 2 practical training must be completed before a valid operator 
          certificate can be issued. To scheudule training call or email us 
          at: 902-478-1972 or hbenoit.yoda@outlook.com
          "
        />
      )}
    </div>
  );
};
Part2Checker.propTypes = {
  course: PropTypes.shape({
    partTwo: PropTypes.bool,
  }),
};

export default Part2Checker;
